import styled from 'styled-components'

export const StyledCampaignMessagingInsightItem = styled.div`
  .ant-progress-bg {
    background-color: ${({ theme }) => theme?.colors?.primary} !important;
  }
`
